import { EIPRToothMap, IIPRDataItem } from "@/shared/types"
import { Input } from "@mui/material"
import { FC } from "react"
import { IUpdateToothDataParams } from "."
import "./scss/StageItemValue.scss"
interface IProps {
  disabled: boolean
  dataType:
    | "iprURToothDataMemo"
    | "iprULToothDataMemo"
    | "iprLRToothDataMemo"
    | "iprLLToothDataMemo"
  id: EIPRToothMap
  item: IIPRDataItem
  itemIndex: number
  updateToothData: (data: IUpdateToothDataParams) => void
}
const StageItemValue: FC<IProps> = ({
  disabled,
  dataType,
  id,
  item,
  itemIndex,
  updateToothData,
}) => {
  const max = 1
  const min = 0

  return (
    <div className="stage-item-value">
      <div className="ux-value">
        {item.value
          ? Number.parseFloat(item.value) === 0
            ? "-"
            : item.value
          : "-"}
      </div>
      <div className="current-input-wrap">
        <Input
          value={item.actualValue}
          type="number"
          disabled={!disabled}
          disableUnderline={true}
          onChange={(e: any) => {
            let value = e.target.value
            if (value > max) {
              value = max
            } else if (value < min) {
              value = min
            }
            if (value.length > 4) return

            updateToothData({
              dataType,
              id,
              itemIndex,
              value,
            })
          }}
        />
      </div>
    </div>
  )
}

export default StageItemValue
